import * as React from "react";
import { BlobProvider } from "@react-pdf/renderer";


export interface PdfDocumentProps {
  title: string;
  document: JSX.Element;
}

const PdfDocument: React.FC<PdfDocumentProps> = ({ title, document }) => {
  const [showProvider, setShowProvider] = React.useState(false);
  console.log("pdfdocument ",title)
  if (!showProvider) {
    return <button onClick={() => setShowProvider(true)}>Préparer le téléchargement</button>;
  }

  return (
    <BlobProvider document={document}>
      {({ url, loading, error }) => {
        if (loading) {
          return (
            <span>
            
            Génération du PDF...
            </span>
          );
        }
        if (!loading && url) {
          return (
            <a href={url} download={title} >
              Télécharger en  (PDF)
            </a>
          );
        }
        if (error) {
          console.error(error);
          return <p>An error occurred</p>;
        }
        return null;
      }}
    </BlobProvider>
  );
};

export default PdfDocument;
